import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AppleFilledSvg from "@ant-design/icons-svg/es/asn/AppleFilled";
import AntdIcon from "../components/AntdIcon";
var AppleFilled = function AppleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AppleFilled.displayName = 'AppleFilled';
}
export default /*#__PURE__*/React.forwardRef(AppleFilled);